import { useTheme } from 'styled-components';

import { Button, ButtonSize } from '@/core/components/Button';
import { Icon } from '@/core/components/Icons';
import { Paragraph } from '@/core/components/Typography';

import { ButtonsWrapper, CloseButton, HeaderTitle, HeaderWrapper } from './Header.styles';
import { HeaderProps } from './Header.types';

export const Header = ({ onClose, onSaveClick, isSaveDisabled }: HeaderProps) => {
  const { colors } = useTheme();

  return (
    <HeaderWrapper>
      <HeaderTitle>
        <Icon
          name="Robot"
          color={colors.primaryText}
          size={15}
        />
        <Paragraph
          type="bold"
          color={colors.primaryText}
        >
          AI Analyst
        </Paragraph>
      </HeaderTitle>
      <ButtonsWrapper>
        <Button
          buttonSize={ButtonSize.SMALL}
          type="button"
          onClick={onSaveClick}
          disabled={isSaveDisabled}
        >
          Save analysis
        </Button>
        {onClose && (
          <CloseButton
            type="button"
            onClick={onClose}
            aria-label="Close chat"
          >
            <Icon
              name="Close"
              size={12}
            />
          </CloseButton>
        )}
      </ButtonsWrapper>
    </HeaderWrapper>
  );
};
